import React from 'react';

const Footer = () => {
  return (
    <footer>
      <img
        className='footerlogo'
        src={process.env.PUBLIC_URL + '/footer-logo-original.png'}
        alt='Wir denken logistisch.'
      />
    </footer>
  );
};

export default Footer;
